var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 278,
    viewBox: "0 0 203 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.162 153.212C210.289 148.976 202.809 150.539 198.855 155.63L189.916 151.883C187.631 150.925 186.255 148.584 186.523 146.12C187.128 140.573 186.686 135.037 185.32 129.765C184.608 127.011 185.96 124.153 188.593 123.075L198.422 119.052C198.649 119.177 198.863 119.321 199.105 119.423C203.591 121.303 208.856 118.566 209.612 113.375C209.993 110.753 208.87 108.01 206.76 106.408C202.583 103.234 196.909 104.976 195.028 109.461C194.858 109.869 194.746 110.283 194.651 110.701L183.899 115.102C181.562 116.058 178.878 115.336 177.348 113.329C172.659 107.177 166.359 102.124 158.711 98.9181C158.126 98.6728 157.538 98.4443 156.947 98.2296C154.166 97.2248 152.714 94.1752 153.581 91.3473L156.606 81.4861C160.51 80.3705 163.787 77.2244 164.594 72.6003C165.34 68.3237 163.384 63.8328 159.748 61.4631C153.7 57.5224 145.895 60.1284 143.241 66.4597C141.122 71.5149 143.009 77.2282 147.443 80.1225L143.951 91.5081C143.261 93.7553 141.242 95.3425 138.895 95.4493C134.188 95.6684 129.574 96.6106 125.204 98.2156C122.566 99.1845 119.621 98.1514 118.269 95.6851L114.447 88.7107C115.51 84.6217 112.99 80.2275 108.396 79.4437C105.77 78.9943 102.977 80.078 101.361 82.1964C98.2236 86.3015 99.9313 91.8921 104.345 93.7424C105.235 94.1156 106.159 94.2869 107.068 94.3093L110.748 101.027C111.98 103.274 111.517 106.056 109.648 107.808C105.098 112.071 101.347 117.324 98.7808 123.447C98.097 125.078 97.5233 126.726 97.0485 128.383C96.2844 131.052 93.7928 132.841 91.0307 132.55L76.0412 130.977C74.7713 127.729 71.9847 125.078 68.1128 124.231C63.7681 123.281 59.0763 125.219 56.6729 128.962C52.8792 134.878 55.4378 142.472 61.6135 145.061C66.8617 147.261 72.8063 145.032 75.4464 140.122L90.608 141.713C93.2131 141.985 95.26 144.025 95.5759 146.624C96.2943 152.532 98.1558 158.227 101.031 163.4C102.281 165.647 101.855 168.452 99.9772 170.208L86.5873 182.751C82.553 181.872 78.3085 184.437 77.5751 188.972C77.151 191.59 78.2451 194.358 80.3524 195.966C84.4663 199.099 90.0626 197.387 91.9155 192.967C92.3514 191.927 92.5152 190.846 92.4749 189.79L105.557 177.535C107.602 175.618 110.709 175.548 112.916 177.275C116.022 179.705 119.491 181.777 123.304 183.375C123.671 183.529 124.038 183.676 124.404 183.815C126.934 184.78 128.443 187.363 127.969 190.03L125.349 204.782C122.544 205.897 120.266 208.328 119.54 211.683C118.726 215.448 120.407 219.505 123.648 221.588C128.791 224.894 135.396 222.67 137.648 217.298C139.39 213.142 137.947 208.464 134.447 205.928L137.013 191.486C137.478 188.867 139.723 186.961 142.381 186.878C147.387 186.722 152.299 185.744 156.934 184.02C159.276 183.146 161.908 183.931 163.386 185.949L167.219 191.167C165.928 195.845 168.895 200.92 174.28 201.604C177.047 201.955 179.911 200.762 181.624 198.56C185.157 194.01 183.272 187.777 178.366 185.721C176.993 185.145 175.559 185.005 174.179 185.17L171.721 181.823C170.026 179.513 170.379 176.338 172.466 174.373C175.763 171.265 178.64 167.632 180.942 163.521C182.349 161.011 185.368 159.912 188.023 161.025L196.303 164.496C196.743 168.919 199.476 172.974 203.861 174.812C211.133 177.86 219.652 173.523 221.073 165.218C221.851 160.673 219.897 155.905 216.162 153.212Z",
    fill: "url(#paint0_linear_1_1145)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.865 218.914C165.597 217.544 161.837 219.082 160.467 222.351C159.097 225.619 160.636 229.379 163.904 230.749C167.172 232.119 170.932 230.58 172.302 227.312C173.672 224.044 172.134 220.284 168.865 218.914Z",
    fill: "url(#paint1_linear_1_1145)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.984 60.8649C115.435 62.7306 120.555 60.635 122.421 56.1842C124.287 51.7334 122.191 46.6127 117.741 44.747C113.29 42.8812 108.169 44.9768 106.303 49.4277C104.438 53.8785 106.533 58.9991 110.984 60.8649Z",
    fill: "url(#paint2_linear_1_1145)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6312 174.889C63.7411 176.193 67.319 174.729 68.6227 171.619C69.9263 168.509 68.4621 164.931 65.3522 163.628C62.2423 162.324 58.6644 163.788 57.3607 166.898C56.0571 170.008 57.5213 173.586 60.6312 174.889Z",
    fill: "url(#paint3_linear_1_1145)",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1145",
    x1: 46.0149,
    y1: 179.399,
    x2: 200.981,
    y2: 64.0509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1145",
    x1: 158.965,
    y1: 227.901,
    x2: 171.261,
    y2: 218.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1145",
    x1: 104.257,
    y1: 56.9865,
    x2: 121.003,
    y2: 44.8113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_1145",
    x1: 55.9311,
    y1: 172.18,
    x2: 67.6321,
    y2: 163.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216.012,
    height: 216.012,
    fill: "white",
    transform: "translate(83.5107) rotate(22.7432)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotRight);
export default __webpack_public_path__ + "static/media/spot-right.11089e21994a90b649038079cdb29381.svg";
export { ForwardRef as ReactComponent };